<template>
  <div>
    <search-form
      :model="searchParams"
      :col="3"
      :items="searchConfigList"
      :loading="loading"
      inline
      :action-block="false"
      label-width="100px"
      @submit="handleSearch"
    ></search-form>

    <br>

    <el-table v-loading="loading" :data="tableData">
      <el-table-column label="申诉子单号" width="125" prop="subApplicationOrder"></el-table-column>
      <el-table-column label="匹配结果ID" width="125" prop="pkId"></el-table-column>
      <el-table-column label="申诉歌曲ID" width="125" v-slot="{ row }">
        {{ row.complaintTrackList.tracklistId }}
      </el-table-column>
      <el-table-column label="匹配状态" width="100" v-slot="{ row }">
        {{ matchStatusMap[row.pkStatus] }}
      </el-table-column>
      <el-table-column label="处理截止时间" width="125" prop="expiresTime"></el-table-column>
      <el-table-column label="匹配信息" align="center">
        <el-table-column label="授权方" prop="matchCompanyName"></el-table-column>
        <el-table-column label="TME ID" prop="tmeId"></el-table-column>
        <el-table-column label="歌曲名" prop="matchTrackName" width="120" show-overflow-tooltip></el-table-column>
        <el-table-column label="歌手名" prop="matchSingerName"></el-table-column>
        <el-table-column label="专辑名" prop="matchAlbumName"></el-table-column>
      </el-table-column>
      <el-table-column label="投诉内容" align="center">
        <el-table-column label="媒体类型" v-slot="{ row }">
          {{ mediaTypeMap[row.tortMediaType] }}
        </el-table-column>
        <el-table-column label="作品名称" prop="tortTrackName" width="120" show-overflow-tooltip></el-table-column>
        <el-table-column label="歌手名" prop="tortSingerName"></el-table-column>
        <el-table-column label="专辑名" prop="tortAlbumName"></el-table-column>
        <el-table-column label="版本" prop="tortSrcVersion"></el-table-column>
        <el-table-column label="平台" v-slot="{ row }">
          {{ appealPlatMap[row.tortAppealPlat] }}
        </el-table-column>
        <el-table-column label="作品链接" v-slot="{ row }" show-overflow-tooltip>
          <a v-if="row.tortAppealUrl" :href="row.tortAppealUrl" target="_blank">
            {{ row.tortAppealUrl }}
          </a>
          <template v-else>-</template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="原作品信息" align="center">
        <el-table-column label="作品名称" prop="originTrackName" width="120" show-overflow-tooltip></el-table-column>
        <el-table-column label="歌手名" prop="originSingerName"></el-table-column>
        <el-table-column label="专辑名" prop="originAlbumName"></el-table-column>
        <el-table-column label="版本" prop="originSrcVersion"></el-table-column>
        <el-table-column label="词作者" prop="originWordAuthor"></el-table-column>
        <el-table-column label="曲作者" prop="originMusicAuthor"></el-table-column>
        <el-table-column label="权利文件" width="200" v-slot="{ row }" show-overflow-tooltip>
          <a v-if="row.originRightFile" :href="row.originRightFile.fileUrl" :download="row.originRightFile.fileName">
            {{ row.originRightFile.fileName }}
          </a>
          <template v-else>-</template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="申诉单信息" align="center">
        <el-table-column label="申诉单号" prop="appealOrder" width="120"></el-table-column>
        <el-table-column label="申诉类型" v-slot="{ row }">
          {{ appealTypeMap[row.applicationType] }}
        </el-table-column>
        <el-table-column label="申诉标题" prop="appealTitle" width="120" show-overflow-tooltip></el-table-column>
        <el-table-column label="申诉人" prop="applicationUser" width="120"></el-table-column>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="pagination.current"
      :page-sizes="[20, 50, 100, 1000, 2000]"
      :page-size="pagination.size"
      :total="pagination.total"
      layout="total, sizes, prev, pager, next, jumper"
      class="pagination"
    >
    </el-pagination>
  </div>
</template>

<script>
import complaintService from '@/api/complaint'
import { paginationTableMixin } from '@/utils/mixins'
import SearchForm from '@/components/SearchForm'
import {
  mediaTypeMap,
  appealPlatMap,
  appealTypeMap,
  matchStatusMap,
  appealSubStatusMap,
  levelOneAppealMap,
  levelTwoAppealMap
} from '../../../../../../const'

import { formatSubOrderDetail } from '../../../const'

const isUnf = undefined

function defaultSearchParams() {
  return {
    subApplicationOrder: '',
    appealOrder: '',
    appealTitle: '',
    applicationType: isUnf,
    bussType: isUnf,
    complaintType: isUnf,
    subStatus: isUnf,
    applicationTime: '',
    subInsertTime: '',
    applicationUser: '',
    createUser: ''
  }
}

const searchConfigList = [
  {
    label: '申诉子单号',
    key: 'subApplicationOrder',
    type: 'text',
    componentProps: {
      placeholder: '请输入申诉单号',
      clearable: true
    }
  },
  {
    label: '申诉子状态',
    key: 'subStatus',
    type: 'select',
    options: appealSubStatusMap,
    componentProps: {
      clearable: true
    }
  }
]

export default {
  name: 'TrackConfirmTable',
  components: {
    SearchForm
  },
  mixins: [paginationTableMixin],
  props: {
    subOrder: String
  },
  data() {
    return {
      matchStatusMap,
      appealSubStatusMap,
      appealTypeMap,
      levelOneAppealMap,
      levelTwoAppealMap,
      searchConfigList,
      mediaTypeMap,
      appealPlatMap,

      searchParams: defaultSearchParams(),
    }
  },
  watch: {
    subOrder: {
      immediate: true,
      handler(val) {
        if (this.searchParams.subApplicationOrder !== val) {
          this.searchParams.subApplicationOrder = val
          this.fetchData()
        }
      }
    }
  },
  methods: {
    getParams() {
      const { searchParams } = this
      return searchParams
    },
    async fetchData() {
      this.loading = true
      const params = this.getParams()
      try {
        const { total, list } = await complaintService.queryDetailSubComplaint({
          ...params,
          appealId: +this.$route.query.id,
          page: this.pagination.current - 1,
          num: this.pagination.size
        })
        this.pagination.total = total
        this.tableData = (list || []).map(item => formatSubOrderDetail(item))
      } catch (error) {
        this.$alert(`查询失败.${error.message}`, '错误', {
          type: 'error',
          error
        })
      }
      this.loading = false
    },
    handleDetail() {},
  }
}
</script>

<style lang="scss" scoped>

.search-form {
  ::v-deep {
    .el-card__body {
      padding-bottom: 8px;
    }
    .el-form-item--mini.el-form-item {
      margin-bottom: 12px;

      .el-form-item__label {
        color: #002444;
      }
    }
  }
}

.table-control {
  margin-bottom: 14px;
}

/deep/ .el-table__cell .cell .el-button + .el-button {
  margin-left: 0;
}
</style>
